import { jwtDecode } from "jwt-decode";
 
export const TokenInstance = () => {
    const tokenData = localStorage.getItem("token");
    const tokenObj = jwtDecode(tokenData);
    const tokenId = localStorage.getItem("token");
    const tokenAc = localStorage.getItem("accessToken");
    return {
        email :     tokenObj.email,
        tokenId :   tokenObj.tokenId,
        firstname : tokenObj.given_name,
        lastname :  tokenObj.family_name,
        username :  tokenObj.email,
        verify :    tokenObj.email_verified,
        access :    tokenObj.profile,
        tokenId2 :   tokenId,
        tokenAc :   tokenAc
    }
   
}